import { withDispatch, withSelect } from "@wordpress/data";

export default ( Comp ) => {
	return withDispatch( ( dispatch ) => {
		const { updateOption } = dispatch( 'options-kit' );
	
		return {
			updateOption,
		};
	} )( withSelect( ( select, { id, value } ) => {
		return {
			inputValue: select( 'options-kit' ).getOptionValue( id, value ),
		}
	} )( Comp ) );
}